<template>
  <!-- 发货信息 -->
  <card class="wrapper">
    <AdminTitle title="发货信息" size="15px" bottom="5px"/>

    <card class="wrapper-delivery special-card">
      <el-row :gutter="24">
        <el-col :span="6">
          <span class="label">设备序列号：</span>
          <span class="value">{{ orderDelivery.deviceSn || '-' }}</span>
        </el-col>
        <el-col :span="6">
          <span class="label">采购价：</span>
          <span class="value">{{ orderDelivery.costPrice || '-' }}</span>
        </el-col>
        <el-col :span="12">
          <span class="label">备注：</span>
          <span class="value">{{ orderDelivery.remark || '-' }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="12">
          <span class="label">发货资料：</span>
          <span class="value">{{ orderDelivery.deliveryTime || '暂无' }}</span>
          <el-image
            v-show="!!orderDelivery.deliveryImageUrlList"
            style="width: 60px; height: 60px; margin-right: 10px; border-radius: 5px"
            v-for="(item, i) in orderDelivery.deliveryImageUrlList"
            :key="i"
            :src="item"
            :preview-src-list="[item]"
          />
        </el-col>
        <el-col :span="12">
          <span class="label">签收资料：</span>
          <span class="value">{{ orderDelivery.receiveTime || '暂无' }}</span>
          <el-image
            v-show="!!orderDelivery.receiveImageUrlList"
            style="width: 60px; height: 60px; margin-right: 10px; border-radius: 5px"
            v-for="(item, i) in orderDelivery.receiveImageUrlList"
            :key="i"
            :src="item"
            :preview-src-list="[item]"
          >
          </el-image>
        </el-col>
      </el-row>
    </card>

<!--    <el-table :data="tableData" stripe style="width: 100%">-->
<!--      <el-table-column prop="deviceSn" label="设备序列号" />-->
<!--      <el-table-column prop="costPrice" label="采购价" />-->
<!--      <el-table-column prop="deliveryNo" label="快递单号" />-->
<!--      <el-table-column prop="deliveryCompanyName" label="快递公司" />-->
<!--      <el-table-column prop="deliveryTime" label="发货时间" />-->
<!--      <el-table-column prop="receiveTime" label="签收时间" />-->
<!--    </el-table>-->

<!--    <el-table :data="tableData" stripe style="width: 100%">-->
<!--      <el-table-column prop="deliveryImageUrlList" label="发货图片">-->
<!--        <template slot-scope="{ row }">-->
<!--          <el-image-->
<!--              v-show="row.deliveryImageUrlList && row.deliveryImageUrlList.length"-->
<!--              style="width: 60px; height: 60px; margin-right: 10px; border-radius: 5px"-->
<!--              v-for="(item, i) in row.deliveryImageUrlList"-->
<!--              :key="i"-->
<!--              :src="item"-->
<!--              :preview-src-list="[item]"-->
<!--          >-->
<!--          </el-image>-->
<!--          <span v-show="!row.deliveryImageUrlList || !row.deliveryImageUrlList.length">暂无数据</span>-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="receiveImageUrlList" label="签收证明">-->
<!--        <template slot-scope="{ row }">-->
<!--          <el-image-->
<!--              v-show="row.receiveImageUrlList && row.receiveImageUrlList.length"-->
<!--              style="width: 60px; height: 60px; margin-right: 10px; border-radius: 5px"-->
<!--              v-for="(item, i) in row.receiveImageUrlList"-->
<!--              :key="i"-->
<!--              :src="item"-->
<!--              :preview-src-list="[item]"-->
<!--          >-->
<!--          </el-image>-->
<!--          <span v-show="!row.receiveImageUrlList || !row.receiveImageUrlList.length"-->
<!--          >暂无数据</span-->
<!--          >-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column prop="remark" label="备注" width="200">-->
<!--        <template slot-scope="{ row }">-->
<!--          {{ row.remark || '暂无数据' }}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--    </el-table>-->
  </card>
</template>

<script>
import { authBtnMixin } from '@/mixins/authBtnMixin';

export default {
  name: 'DeliveryInfo',
  mixins: [authBtnMixin],
  props: {
    orderDelivery: {
      type: Object,
      default: () => {},
    },
    detail: {
      type: Object,
      default: () => {},
    },
  },

  watch: {
    orderDelivery: {
      handler(newV, oldV) {
        this.address = { ...this.orderDelivery };
      },
    },
  },

  computed: {
    tableData() {
      return [
        {
          costPrice: this.detail.costPrice || '-',
          deviceSn: this.orderDelivery.deviceSn || '-',
          deliveryNo: this.orderDelivery.deliveryNo || '-',
          deliveryCompanyName: this.orderDelivery.deliveryCompanyName || '-',
          deliveryTime: this.detail.deliveryTime || '-',
          receiveTime: this.detail.receiveTime || '-',
          deliveryImageUrlList: this.orderDelivery.deliveryImageUrlList || [],
          receiveImageUrlList: this.orderDelivery.receiveImageUrlList || [],
          remark: this.orderDelivery.remark || '-',
          lastTraceNode: this.orderDelivery.lastTraceNode ? this.orderDelivery.lastTraceNode.statusName : '-',
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper ::v-deep {
  width: 100%;
  border-color: transparent;
  margin-top: 5px;
  border-radius: 16px;
  color: #222222;

  .wrapper-delivery {
    border-radius: 16px;
    padding: 15px;
  }

  .special-card {
    background: #f7f8fa;
    line-height: 35px;
    color: #222222;
    position: relative;

    .value {
      margin-left: 15px;
      min-width: 80px;
      display: inline-block;
      font-weight: 700;
    }

    .label {
      text-align: right;
      min-width: 80px;
      display: inline-block;
    }

    .el-icon-edit {
      margin-left: 20px;
      cursor: pointer;
      color: #4badf8;
    }
  }

  .el-icon-edit {
    cursor: pointer;
    margin-left: 10px;
    color: #1483ea;
  }

  .el-button {
    border-radius: 15px;
  }
}
</style>
